export const RESET_UI_STATE = "RESET_UI_STATE";
export const STR_MUTATION_UI_SET_CART_ICON_SHOWING_ORDER_INFO =
  "STR_MUTATION_UI_SET_CART_ICON_SHOWING_ORDER_INFO";
export const STR_MUTATION_FULLSCREEN_LOADING =
  "STR_MUTATION_FULLSCREEN_LOADING";
export const SHOW_FORGOT_PASSWORD_DIALOG = "SHOW_FORGOT_PASSWORD_DIALOG";
export const SHOW_ADD_CHILDREN_TO_ORDER_DIALOG =
  "SHOW_ADD_CHILDREN_TO_ORDER_DIALOG";
export const SET_CONFIG_OPTIONS = "SET_CONFIG_OPTIONS";
